import React from 'react'
import {Box} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'

import Chat from './Chat'

const isIOS =
  typeof window !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent)

const useStyles = makeStyles(() => ({
  root: {
    height: isIOS ? '100dvh' : '100vh',
    width: '100%',
    backgroundColor: '#f5f5f5',
    padding: 0,
    margin: 0,
    overflow: 'hidden',
  },
}))

/**
 * StandaloneChat is a bare container for the Chat component.
 *
 * The Chat component handles all authentication and authorization:
 * 1. Language selection and eligibility confirmation
 * 2. Date of birth verification with secure session creation
 * 3. Microphone permission (if voice mode selected)
 * 4. WebSocket connection establishment
 */
const StandaloneChat: React.FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Chat />
    </Box>
  )
}

export default StandaloneChat
